(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/desktop-pagination.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/desktop-pagination.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useMemo = _React.useMemo;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const CARDS_SMALL_SCREEN = 3;
const CARDS_LARGE_SCREEN = 4;
function splitIntoChunks(arr, chunkSize) {
  const result = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    result.push(arr.slice(i, i + chunkSize));
  }
  return result;
}
const DesktopPagination = _ref => {
  let category = _ref.category;
  const games = category.games,
    _category$columns = category.columns,
    _category$columns2 = _category$columns === void 0 ? {
      am: 4,
      md: 3,
      xs: 6
    } : _category$columns,
    am = _category$columns2.am,
    md = _category$columns2.md,
    xs = _category$columns2.xs;
  const _svs$eInstant$shared$ = svs.eInstant.shared.components,
    SlideIndicator = _svs$eInstant$shared$.SlideIndicator,
    CategoryTitle = _svs$eInstant$shared$.CategoryTitle;
  const TicketCard = svs.eInstant.components.TicketCard;
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeSlide = _useState2[0],
    setActiveSlide = _useState2[1];
  const _useState3 = useState(12 / md),
    _useState4 = _slicedToArray(_useState3, 2),
    cardsPerPage = _useState4[0],
    setCardsPerPage = _useState4[1];
  const _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    direction = _useState6[0],
    setDirection = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isAnimating = _useState8[0],
    setIsAnimating = _useState8[1];
  const _useState9 = useState(0),
    _useState0 = _slicedToArray(_useState9, 2),
    targetSlide = _useState0[0],
    setTargetSlide = _useState0[1];
  const slideContainerRef = useRef(null);
  const cardImageSizes = useMemo(() => ["(min-width: 1024px) min(312px, calc(min(100vw, 1357px) * ".concat(md, " / 12 - 24px))"), "(min-width: 768px) min(312px, calc(100vw * ".concat(am, " / 12 - 24px))"), '249px'].join(', '), [am, md]);
  const updateCardsPerPage = () => {
    const width = window.innerWidth;
    if (width < 1024) {
      setCardsPerPage(CARDS_SMALL_SCREEN);
    } else {
      setCardsPerPage(CARDS_LARGE_SCREEN);
    }
  };
  useEffect(() => {
    setActiveSlide(0);
  }, [category.games]);
  useEffect(() => {
    if (am !== md) {
      updateCardsPerPage();
      window.addEventListener('resize', updateCardsPerPage);
    }
    return () => am !== md && window.removeEventListener('resize', updateCardsPerPage);
  }, []);
  const gamesChunks = useMemo(() => splitIntoChunks(games, cardsPerPage), [games, cardsPerPage]);
  const totalSlides = gamesChunks.length;
  const paginate = newIndex => {
    if (newIndex === activeSlide || isAnimating) return;
    const newDirection = newIndex > activeSlide ? 1 : -1;
    setDirection(newDirection);
    setTargetSlide(newIndex);
    setIsAnimating(true);

    if (slideContainerRef.current) {
      gsap.killTweensOf(slideContainerRef.current);
      if (newDirection === -1) {
        gsap.fromTo(slideContainerRef.current, {
          x: '-50%'
        }, {
          x: '0%',
          duration: 0.5,
          ease: 'power2.inOut',
          onComplete: () => {
            setActiveSlide(newIndex);
            setTargetSlide(newIndex);
            setIsAnimating(false);
          }
        });
      } else {
        gsap.to(slideContainerRef.current, {
          x: '-50%',
          duration: 0.5,
          ease: 'power2.inOut',
          onComplete: () => {
            setActiveSlide(newIndex);
            setTargetSlide(newIndex);
            gsap.set(slideContainerRef.current, {
              x: '0%'
            });
            setIsAnimating(false);
          }
        });
      }
    }
  };
  return React.createElement("div", {
    className: "desktop-pagination-card-container",
    "data-testid": "desktop-pagination-".concat(category.urlPath)
  }, React.createElement("div", {
    className: "u-flex u-flex-justify-content-between padding-bottom-half"
  }, React.createElement(CategoryTitle, {
    category: category,
    className: "margin-left-1-half"
  }), totalSlides > 1 && React.createElement(SlideIndicator, {
    activeSlide: activeSlide,
    className: "margin-right-1",
    isNextDisabled: activeSlide >= totalSlides - 1,
    isPrevDisabled: activeSlide <= 0,
    nextSlide: () => paginate(activeSlide + 1),
    prevSlide: () => paginate(activeSlide - 1),
    setActiveSlide: paginate,
    totalCount: totalSlides
  })), React.createElement("div", {
    className: isAnimating ? 'overflow-hidden' : ''
  }, React.createElement(Grid, null, React.createElement("div", {
    className: "u-flex u-flex-direction-row desktop-pagination-grid-chunks-wrapper ".concat(isAnimating ? 'desktop-pagination-animating' : 'desktop-pagination-static'),
    ref: slideContainerRef
  }, gamesChunks.map((chunk, chunkIndex) => {
    var _chunk$;
    const isActive = chunkIndex === activeSlide;
    const isNext = isAnimating && chunkIndex === targetSlide;
    const shouldShow = isActive || isNext;
    if (!shouldShow) return null;
    const order = direction === 1 ? isActive ? 0 : 1 : isActive ? 1 : 0;
    const orderClass = order === 0 ? 'slide-order-0' : 'slide-order-1';
    return React.createElement("div", {
      className: "slide-wrapper ".concat(isAnimating ? 'half-width' : 'full-width', " ").concat(orderClass),
      key: ((_chunk$ = chunk[0]) === null || _chunk$ === void 0 ? void 0 : _chunk$.cntTicketGameId) || chunkIndex
    }, React.createElement(GridRow, {
      className: "w100 desktop-pagination-margin-auto grid-flex-g-2"
    }, chunk.map((game, indexInChunk) => {
      const numberIndex = chunkIndex * cardsPerPage + indexInChunk;
      return React.createElement(GridCol, {
        am: am,
        className: "u-flex u-flex-justify-content-center",
        key: (game === null || game === void 0 ? void 0 : game.cntTicketGameId) || indexInChunk,
        md: md,
        xs: xs
      }, React.createElement(TicketCard, {
        className: "w100",
        imageSizes: cardImageSizes,
        isNumberedList: category.numberedList,
        number: numberIndex + 1,
        ticketConfig: game
      }));
    })));
  })))));
};
setGlobal('svs.eInstant.shared.components.DesktopPagination', DesktopPagination);

 })(window);